import { avatarColorFor, initialsFor } from "@/lib/mockData";

/**
 * Deterministic initial-avatar. Works fully offline (no external service).
 */
const InitialAvatar = ({ name = "", size = 40, className = "" }) => {
    const color = avatarColorFor(name);
    const initials = initialsFor(name) || "?";
    return (
        <span
            className={["inline-flex items-center justify-center rounded-full font-semibold text-white select-none", className].join(" ")}
            style={{
                width: size,
                height: size,
                fontSize: Math.round(size * 0.38),
                background: `linear-gradient(135deg, ${color}, hsl(from ${color} h s calc(l - 12%)))`,
                boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.18)",
            }}
            aria-hidden
        >
            {initials}
        </span>
    );
};

export default InitialAvatar;
